import React from 'react';
import Link from '../LocalizedLink/LocalizedLink';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-custom">
        <div className="py-12 lg:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Company Info */}
            <div className="col-span-1 md:col-span-2 lg:col-span-1">
              <div className="text-2xl font-bold text-orange-accent mb-4">
                K&B<span className="text-white">Trans</span>
              </div>
              <p className="text-gray-300 mb-4">
                {t('hero.subtitle')}
              </p>
              <div className="flex space-x-4">
                <a 
                  aria-label="Facebook"
                  href="https://www.facebook.com/share/16VoCYHRtg/?mibextid=wwXIfr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-orange-accent transition-colors"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a 
                  aria-label="LinkedIn"
                  href="https://www.linkedin.com/company/k-b-trans-sp-z-o-o/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-orange-accent transition-colors"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>

              </div>
            </div>

            {/* Navigation */}
            <div>
              <h3 className="text-lg font-semibold mb-4">{t('nav.services')}</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/services" className="text-gray-300 hover:text-orange-accent transition-colors">
                    {t('services.roadTransport.title')}
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-300 hover:text-orange-accent transition-colors">
                    {t('services.seaFreight.title')}
                  </Link>
                </li>
                <li>
                  <Link to="/relocations" className="text-gray-300 hover:text-orange-accent transition-colors">
                    {t('services.relocations.title')}
                  </Link>
                </li>
                <li>
                  <Link to="/cargo" className="text-gray-300 hover:text-orange-accent transition-colors">
                    {t('cargo.temperatureControlled.title')}
                  </Link>
                </li>
                <li>
                  <Link to="/cargo" className="text-gray-300 hover:text-orange-accent transition-colors">
                    {t('cargo.generalCargo.title')}
                  </Link>
                </li>
                <li>
                  <Link to="/why-us" className="text-gray-300 hover:text-orange-accent transition-colors">
                    {t('nav.whyUs')}
                  </Link>
                </li>
                <li>
                  <Link to="/carriageTerms" className="text-gray-300 hover:text-orange-accent transition-colors">
                    {t('carriageTerms.link')}
                  </Link>
                </li>
              </ul>
            </div>



            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-4">{t('contact.title')}</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-orange-accent flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <div>
                    <p className="text-gray-300 text-sm">{t('contact.phone')}</p>
                    <a href="tel:+48577083279" className="text-white hover:text-orange-accent transition-colors">
                      +48 577 083 279
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-orange-accent flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <div>
                    <p className="text-gray-300 text-sm">{t('contact.email')}</p>
                    <a href="mailto:info@kbtrans.eu" className="text-white hover:text-orange-accent transition-colors">
                      info@kbtrans.eu
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-orange-accent flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div>
                    <p className="text-gray-300 text-sm">{t('contact.address')}</p>
                    <address className="text-white not-italic">
                      Fosa 31<br />
                      02-768 Warszawa<br />
                      {t('countries.poland')}<br />
                      <span className="text-gray-300 text-sm">NIP: PL7811993702</span>
                    </address>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-orange-accent flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <p className="text-gray-300 text-sm">{t('contact.hours')}</p>
                    <div className="text-white text-sm">
                      <p>{t('contact.monday')}</p>
                      <p>{t('contact.saturday')}</p>
                      <p>{t('contact.sunday')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} {t('footer.company')}. {t('footer.rights')}.
            </div>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-orange-accent transition-colors text-sm">
                {t('footer.privacy')}
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-orange-accent transition-colors text-sm">
                {t('footer.terms')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 